export default __webpack_public_path__ + "static/media/9_M52BJ1-min.b6d206cf.jpg";